import { FC, PropsWithChildren } from 'react';
import { Provider } from 'urql';
import { urqlClient } from './utils/urqlClient';

export const UrqlClientProvider: FC<PropsWithChildren> = ({ children }) => {
  return <Provider value={urqlClient}>{children}</Provider>;
};
